import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App, {store} from './App';
import './polyfills';
import ReactGA from 'react-ga';
import {postJson} from './fetchJson';
import firebase from 'firebase/app';
import 'firebase/messaging';
import {registerServiceWorker} from './registerServiceWorker';

export const initialiseFirebase = () => {
	firebase.initializeApp({
		apiKey: 'AIzaSyCZTYJ1GXljiQ8YSRxfwY3nTDU0LWgzGMk',
		authDomain: 'b2me-185411.firebaseapp.com',
		databaseURL: 'https://b2me-185411.firebaseio.com',
		projectId: 'b2me-185411',
		storageBucket: 'b2me-185411.appspot.com',
		messagingSenderId: '268645838483',
		appId: '1:268645838483:web:2eb9af4b78fec2aeec2766',
		measurementId: 'G-B27E6Q3LLB'
	});
};

if (process.env.NODE_ENV === 'production') {
	ReactGA.initialize('UA-112411045-1');
}

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		registerServiceWorker(firebase, store.dispatch.bind(store));
	});
}

window.onerror = (message, source, lineno, colno, error) => {
	if (process.env.NODE_ENV === 'production') {
		ReactGA.exception({
			description: `ERROR @${source}:${lineno}:${colno} - ${message}`,
			fatal: true
		});
	}

	postJson(`/api/error`, {
		message,
		source,
		lineno,
		colno,
		userAgent: window.navigator && window.navigator.userAgent,
		platform: window.navigator && window.navigator.platform,
		stack: error.stack,
		href: window.location && window.location.href
	});
};

ReactDOM.render(<App />, document.getElementById('root'));
initialiseFirebase();



// WEBPACK FOOTER //
// ./src/index.js